// Workflow statuses including escalation states
export const hazardStatus = [
  {
    label: 'Open',
    value: 'open',
    color: '#faad14', // orange
    description: 'Hazard has been reported and is awaiting action'
  },
  {
    label: 'In Progress',
    value: 'in_progress',
    color: '#1890ff', // blue
    description: 'Hazard is being actively worked on'
  },
  {
    label: 'To Be Confirmed',
    value: 'to_be_confirmed',
    color: '#722ed1', // purple
    description: 'Immediate resolution claimed, awaiting manager confirmation'
  },
  {
    label: 'Rectified',
    value: 'resolved',
    color: '#52c41a', // green
    description: 'Hazard has been rectified'
  },
  {
    label: 'Rejected by Manager',
    value: 'rejected_by_manager',
    color: '#f5222d', // red
    description: 'Immediate resolution rejected, hazard returned to workflow'
  },
  {
    label: 'Overdue',
    value: 'overdue',
    color: '#ff4d4f', // bright red
    description: 'Deadline has passed without resolution'
  },
  {
    label: 'Escalated',
    value: 'escalated',
    color: '#ff7a45', // dark orange
    description: 'Hazard has been escalated to higher management level'
  },
  {
    label: 'Closed',
    value: 'closed',
    color: '#8c8c8c', // gray
    description: 'Hazard is permanently closed with no escalation'
  },
  {
    label: 'Rectified',
    value: 'rectified',
    color: '#52c41a', // green
    description: 'Hazard has been rectified (from Health-Safety activity)'
  },
  {
    label: 'Not Rectified',
    value: 'not_rectified',
    color: '#ff4d4f', // red
    description: 'Hazard was not rectified (from Health-Safety activity)'
  },
  {
    label: 'Made Safe, In Progress',
    value: 'made_safe_in_progress',
    color: '#1890ff', // blue
    description: 'Hazard made safe, rectification in progress (from Health-Safety activity)'
  },
  {
    label: 'Made Safe, No Action',
    value: 'made_safe_no_action',
    color: '#13c2c2', // cyan
    description: 'Hazard made safe, no further action required (from Health-Safety activity)'
  }
];

// Severity levels with colors
export const hazardSeverity = [
  {
    label: 'Low',
    value: 'low',
    color: '#52c41a', // green
  },
  {
    label: 'Medium',
    value: 'medium',
    color: '#faad14', // orange
  },
  {
    label: 'High',
    value: 'high',
    color: '#ff7a45', // dark orange
  },
  {
    label: 'Critical',
    value: 'critical',
    color: '#f5222d', // red
  }
];

// Escalation levels
export const hazardEscalationLevels = [
  {
    label: 'Level 0: Closed',
    value: 0,
    shortLabel: 'L0',
    description: 'Hazard is closed - No escalation'
  },
  {
    label: 'Level 1: Direct Manager',
    value: 1,
    shortLabel: 'L1',
    description: '2 business days - Assigned to direct manager'
  },
  {
    label: 'Level 2: Senior Manager',
    value: 2,
    shortLabel: 'L2',
    description: '2 business days - Escalated to 1-up manager'
  },
  {
    label: 'Level 3: Group Safety Manager',
    value: 3,
    shortLabel: 'L3',
    description: '2 business days - URGENT - Group Safety Manager (Email + SMS + Push)'
  }
];

// Helper functions
export const getStatusLabel = (value) => {
  const status = hazardStatus.find(s => s.value === value);
  return status ? status.label : value;
};

export const getStatusColor = (value) => {
  const status = hazardStatus.find(s => s.value === value);
  return status ? status.color : '#d9d9d9';
};

export const getSeverityLabel = (value) => {
  const severity = hazardSeverity.find(s => s.value === value);
  return severity ? severity.label : value;
};

export const getSeverityColor = (value) => {
  const severity = hazardSeverity.find(s => s.value === value);
  return severity ? severity.color : '#d9d9d9';
};

export const getEscalationLevelLabel = (value) => {
  const level = hazardEscalationLevels.find(l => l.value === value);
  return level ? level.label : `Level ${value}`;
};

export const getEscalationLevelShortLabel = (value) => {
  const level = hazardEscalationLevels.find(l => l.value === value);
  return level ? level.shortLabel : `L${value}`;
};

// Statuses exempt from overdue tracking. made_safe_in_progress / not_rectified /
// made_safe_no_action are still active work, so they must keep showing overdue past deadline.
//
// This is NARROWER than the backend's HazardEscalationService::TERMINAL_STATUSES
// (which adds those three) — deliberately, because that list decides whether to
// escalate and notify, while this one only decides whether to draw the deadline
// countdown. See the comment on TERMINAL_STATUSES for why the two don't conflict.
// Keep them in sync consciously: a new hazard status needs a decision in both.
export const HAZARD_CLOSED_STATUSES = [
  'closed',
  'resolved',
  'rectified',
];